/**
 * Find if selected value no longer exists in items array then unshift the missing to items array
 * @param {*} value - required.
 * If optoins.multiple given, expected to be array with string.
 * If options.returnObject given, expected to be object value
 * If both are given, expecteed array of objects
 * @param {array} items - altered array where items no longer show up. required.
 * @param {object} options - required.
 * @param {array} options.rawItems - original items array where it includes all items. required.
 * @param {string} options.keyValue - property that vuetify uses to take it as main value. default "id"
 * @param {boolean} options.returnObject - when input return value as object, give true value. default "false"
 * @param {boolean} options.multiple - when input is multiple selectable, give true value. default "false"
 * @returns missing item(s) added or unmodified array
 */
export default function (value, items, options) {
    const { rawItems, keyValue = "id", returnObject = false, multiple = false } = options;
    if (value == null ||
        value == undefined ||
        (Array.isArray(value) && value.length == 0)) {
        return items;
    }
    if (multiple) {
        const itemsThatExists = items.reduce((arr, i) => {
            if ([null, undefined].includes(i[keyValue])) {
                // ignore objects that do not have [keyValue] property
                return arr;
            }
            arr.push(i[keyValue]);
            return arr;
        }, []);
        let selectedValues = [];
        if (returnObject) {
            selectedValues = value.map(x => x[keyValue]);
        }
        else
            selectedValues = value;
        const foundMissings = rawItems.filter(i => {
            return (
            // Check it doesn't exist in items array
            !itemsThatExists.includes(i[keyValue]) &&
                // check that this item is selected as value
                selectedValues.includes(i[keyValue]));
        }); // returns items that do not exists in items param but are selected in value param
        return foundMissings.concat(items);
    }
    const selectedValueExistsInItems = items.some(i => {
        if (returnObject)
            return value[keyValue] == i[keyValue];
        return value == i[keyValue];
    });
    if (selectedValueExistsInItems == true)
        return items;
    const foundMissing = rawItems.find(i => {
        if (returnObject)
            return value[keyValue] == i[keyValue];
        return value == i[keyValue];
    });
    if (foundMissing) {
        items.unshift(foundMissing);
    }
    return items;
}
